/**
 * Formats a ZIP code to return only the first 5 digits
 * @param {string|number} zipCode - Full ZIP code (can be 5-digit, 9-digit, or ZIP+4 format)
 * @returns {string} - 5-digit ZIP code or original value if invalid
 */

export const formatZipCode = (zipCode) => {
  if (!zipCode) return '';

  const cleanZip = zipCode.toString().replace(/[^\d-]/g, '');

  // 12345-6789 (ZIP+4 with hyphen)
  if (cleanZip.includes('-')) {
    return cleanZip.split('-')[0];
  }

  // 123456789 (9-digit ZIP)
  if (cleanZip.length > 5) {
    return cleanZip.substring(0, 5);
  }

  // 12345 (5-digit ZIP)
  return cleanZip;
};
